import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import UploadSettings from "@presentation/components/job/components/UploadSettings";
import { SettingsTypeEnumSchema, SoftwareSettingsMetadata } from "@domain/schemas/BI";

export const UploadSettingsDialog: React.FC<{
  settingsType: SettingsTypeEnumSchema;
  onUploadSuccess: (uploadedSettings: SoftwareSettingsMetadata) => void;
  onCancel: () => void;
}> = ({ settingsType, onUploadSuccess, onCancel }) => {
  return (
    <Dialog title="Upload Settings" onClose={onCancel}>
      <UploadSettings settingsType={settingsType} onUploadSuccess={onUploadSuccess} />
    </Dialog>
  );
};
